import type { PropsWithChildren } from "react";
import { createContext } from "react";

interface Props {
  downloadingFileId?: string;
  showFilePreview: (fileId: string, preventDownload: boolean) => void;
}

const FundraisingDocumentActionsContext = createContext<Props | undefined>(undefined);

export const FundraisingDocumentActionsContextProvider = ({ children, ...contextValue }: PropsWithChildren<Props>) => {
  return <FundraisingDocumentActionsContext value={contextValue}>{children}</FundraisingDocumentActionsContext>;
};

export default FundraisingDocumentActionsContext;
